import type {ComponentCustomProperties} from '@vue/runtime-core';
import {getCurrentInstance} from 'vue';

/**
 *
 * Shortcut for accessing global properties like `$features`
 * @example
 *  ```ts
 *  setup() {
 *     const {$features} = useGlobalProperties();
 *  }
 *  ```
 */
export function useGlobalProperties(): ComponentCustomProperties {
    const app: any = getCurrentInstance();
    if (app?.appContext) {
        return app?.appContext.config.globalProperties as ComponentCustomProperties;
    }
    throw new Error('Only use "useGlobalProperties" inside setup function or in a composable');
}
